export * from './global-nav';
export { default } from './global-nav';
export {
  sideBarCollapsedMaxWidth,
  NavItemId,
  HelloFaxFilter,
  useGlobalNavOpen,
} from './global-nav.dig';
